import {AbstractSerialBadgeType} from './abstract-serial-badge-type';

export class PerformanceLevelBadgeType extends AbstractSerialBadgeType {
  constructor() {
    super();
    this.name = 'performanceLevel';
    this.prettyName = 'Tageszielbewertung';
    this.icon = 'line-chart';
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/badges/performance-level-badge-type.ts